<div class="z-20 fixed inset-0 flex items-center justify-center bg-main-background bg-opacity-75"
    (click)="$event.preventDefault(); handleCloseStudentSSID();">
    <div class="max-h-screen w-full flex flex-col items-center justify-center overflow-hidden">
        <div class="w-full max-w-screen-sm flex flex-col my-6 p-8 bg-white rounded-md shadow-lg overflow-hidden"
            (click)="$event.stopPropagation()">
            <form (ngSubmit)="submitStudentSSID()" #ssidForm="ngForm" class="w-full h-full">

                <div class="w-full h-full overflow-auto flex flex-col items-center justify-start gap-2">
            
                    <div class="w-full flex flex-row gap-8 items-center justify-between pb-4 border-b border-[#fed7aa]">
                        <h2 class="w-full oswald-font text-xl font-medium text-start">
                            <ng-container *ngIf="assessRelExists === true; else noRel">
                                An Assess case has already been made from this tip.<br>
                                Would you like to create another nSide Assess case based on this tip?
                            </ng-container>
                            <ng-template #noRel>
                                Would you like to create an nSide Assess case based on this tip?
                            </ng-template>
                        </h2>
                    </div>
            
                    <div class="pt-2 w-full h-full overflow-auto flex flex-col gap-4 items-center justify-start">
                        <div class="w-full flex items-center justify-start gap-2">
                            <p class="text-left font-semibold">State's student identifier (SSID):</p>
            
                            <div class="grow flex flex-col items-center">
                                <input 
                                    type="text"
                                    name="studentSSID"
                                    [(ngModel)]="studentSSID"
                                    #ssid="ngModel"
                                    required
                                    class="w-full bg-gray-50 border border-gray-300 text-gray-500 text-sm rounded block p-2"
                                    placeholder="Enter SSID"
                                />
            
                                <!-- Optional simple validation -->
                                <div 
                                    class="w-full text-start italic text-xs text-red-500 pt-1"
                                    *ngIf="ssid.invalid && (ssid.dirty || ssid.touched)"
                                >
                                    This field is required.
                                </div>
                            </div>
                        </div>
                    </div>
            
                    <div class="w-full h-full overflow-auto flex flex-col gap-4 items-start justify-start">
                        <div class="w-full flex items-start justify-start gap-4">
                            <p class="text-left font-semibold">Summary:</p>
                            
                            <div class="max-h-96 grow break-words whitespace-normal overflow-y-auto">
                                <p>{{ tip.tip_summary }}</p>
                            </div>
                        </div>
                    </div>
                    
            
                    <div class="w-full flex flex-row gap-2 items-center justify-end oswald-font">
                        <button 
                            type="button"
                            class="px-4 py-1.5 w-20 rounded-md border border-nside-gray-400"
                            (click)="handleCloseStudentSSID()"
                        >
                            Close
                        </button>
            
                        <button
                            type="submit"
                            class="w-20 flex items-center justify-center px-4 py-1.5 rounded-md border text-white
                                   bg-gradient-to-b border-nside-orange-100 from-nside-orange-300 to-nside-orange-400
                                   hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200"
                            [disabled]="ssidForm.invalid"
                        >
                            Submit
                        </button>
                    </div>            
                </div>            
            </form>                   
        </div>
    </div>
</div>

<div *ngIf="loading">
    <spinner></spinner>
</div>